import PreviewMeta from "./PreviewMeta";
import PreviewHero from "./PreviewHero";
import PreviewFeatures from "./PreviewFeatures";
import PreviewStats from "./PreviewStats";
import PreviewCaseStudies from "./PreviewCaseStudies";
import PreviewFaq from "./PreviewFaq";
import PreviewTeam from "./PreviewTeam";
import PreviewTestimonials from "./PreviewTestimonials";
import PreviewPricing from "./PreviewPricing";
import PreviewFooter from "./PreviewFooter";
import PreviewContact from "./PreviewContact";

export {
  PreviewMeta,
  PreviewHero,
  PreviewFeatures,
  PreviewStats,
  PreviewCaseStudies,
  PreviewFaq,
  PreviewTeam,
  PreviewTestimonials,
  PreviewPricing,
  PreviewFooter,
  PreviewContact,
};

export const PREVIEW_MAP = {
  meta: PreviewMeta,
  hero: PreviewHero,
  features: PreviewFeatures,
  stats: PreviewStats,
  caseStudies: PreviewCaseStudies,
  faq: PreviewFaq,
  team: PreviewTeam,
  testimonials: PreviewTestimonials,
  pricing: PreviewPricing,
  footer: PreviewFooter,
  contact: PreviewContact,
};